import React, { useState } from "react";
import Sidebar from "../../Layouts/Sidebar";

interface HeaderSidebarToggleProps {
    className?: string;
}

const HeaderSidebarToggle = ({ className = "" }: HeaderSidebarToggleProps) => {
    const [showSidebar, setShowSidebar] = useState(false);

    const handleToggleSidebar = () => {
        setShowSidebar((prev) => !prev);
    };

    const togglerClassName = ["suha-navbar-toggler", className].filter(Boolean).join(" ");

    return (
        <React.Fragment>
            <div
                className={togglerClassName}
                data-bs-toggle="offcanvas"
                data-bs-target="#suhaOffcanvas"
                aria-controls="suhaOffcanvas"
            >
                <div onClick={handleToggleSidebar}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <Sidebar show={showSidebar} handleShow={handleToggleSidebar} />
        </React.Fragment>
    );
};

export default HeaderSidebarToggle;
